/** `Finding.caseCoverage.state` (B29, D18): the `?caseCoverage=` filter's values. Tiny: the router imports it. */
export const CASE_COVERAGE_STATES = [
  "in_case",
  "opening",
  "version_not_on_market",
  "version_out_of_support",
  "needs_assessment",
] as const;
